import React from "react";
import { Grid, Box, Tooltip, Typography } from "@mui/material";
import HelpIcon from '@mui/icons-material/Help';
import NumberFormat from "react-number-format";

interface ReadOnlyConfigProps {
    label: string,
    description: string,
    value: string,
}

export default function ReadOnlyConfig(
    {
        label,
        description,
        value,
    }: ReadOnlyConfigProps
) {
    return (
        <Grid container sx={{ alignItems: 'center', pt: 1.5, pb: 1.5 }}>
            <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
                <Tooltip title={description} placement="right">
                    <HelpIcon sx={{ fontSize: 16, color: "#C4C4C4", cursor: "pointer", mr: '9px' }} />
                </Tooltip>

                <Typography 
                    sx={{ 
                        fontFamily: 'Work Sans',
                        fontWeight: 400,
                        fontSize: '12px',
                        lineHeight: '22px',
                    }}
                >
                    {label}
                </Typography>
                <Box sx={{ 
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: 1,
                    minWidth: '69px', 
                    height: '27px', 
                    borderRadius: '24px', 
                    border: '1px solid #F1F0F5', 
                    textAlign: 'center', 
                    marginLeft: '8px'
                }}>
                    <Typography 
                        sx={{ 
                            fontFamily: 'Work Sans',
                            fontWeight: 400,
                            fontSize: '12px',
                            lineHeight: '22px',
                        }}
                    >
                        <NumberFormat
                            thousandsGroupStyle="thousand"
                            value={value}
                            prefix="$"
                            decimalSeparator="."
                            displayType="text"
                            type="text"
                            thousandSeparator={true}
                            allowNegative={true}
                            decimalScale={2}
                            fixedDecimalScale={true}
                        />
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    )
}
